// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ZamannProduct_wrapper__R96ci"};